import type { FavoriteToggleCommonProps } from '@gov-nx/core/hooks/Favorite/useFavoriteToggle';
import { useFavoriteToggle } from '@gov-nx/core/hooks/Favorite/useFavoriteToggle';
import { Button } from '@gov-nx/ui/web/Button/Button';
import { Icon } from '@gov-nx/ui/web/Icon/Icon';

export const FavoriteToggle = ({
	size = 'l',
	customClass,
	...props
}: FavoriteToggleCommonProps) => {
	const { isEnabled, isFavorite, toggle, label, ariaLabel } =
		useFavoriteToggle(props);

	if (!isEnabled) {
		return null;
	}

	return (
		<Button
			color="primary"
			type="base"
			size={size}
			title={label}
			onClick={(e) => {
				e.stopPropagation();
				e.preventDefault();
				toggle();
			}}
			aria-label={ariaLabel}
			className={`print:hidden${customClass ? ` ${customClass}` : ''}`}
			iconStart={
				<Icon
					type="templates"
					name={isFavorite ? 'star-fill' : 'star'}
					size="m"
					color="primary"
				/>
			}>
			{props.withLabel ? label : null}
		</Button>
	);
};
